import React, { useEffect, useMemo, useRef, useState } from "react";
// import HistoricalDataL1 from "../../components/features/dashboards/dashboardl1/dashboard/HistoricalDataL1";
// import FollowupTableL1 from "./../../components/features/dashboards/dashboardl1/dashboard/FollowupTableL1";
import DashFilters from "../../components/features/dashboards/dashboardl1/dashboard/DashFilters";
// import PotentialStatusL1 from "../../components/features/dashboards/dashboardl1/dashboard/PotentialStatusL1";
// import ProbabilityStatusL1 from "../../components/features/dashboards/dashboardl1/dashboard/ProbabilityStatusL1";
// import ConversionRateL1 from "../../components/features/dashboards/dashboardl1/dashboard/ConversionRateL1";
// import LeadSourceL1 from "../../components/features/dashboards/dashboardl1/dashboard/LeadSourceL1";
// import QuotedMeanL1 from "../../components/features/dashboards/dashboardl1/dashboard/QuotedMeanL1";
import MyRequests from "../Operations/Operationperson/MyRequests";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPageTitle } from "../../store/slices/pageSlice";
import Finance from "../finance/Finance";
import { clearScrollTarget } from "../../store/slices/scrollSlice";
import SalesFinaceFilter from "../Operations/SalesOperations/SalesFinance/TableSalesFinance/SalesFinaceFilter";
import SalesProjects from "../Operations/SalesOperations/SaleOperation/SalesParent/SalesProjects";
import FollowupTable from "../../components/features/dashboards/dashboardl1/dashboard/FollowupTable";
import PotentialStatus from "../../components/features/dashboards/dashboardl1/dashboard/potentialStatus";
import ProbabilityStatus from "../../components/features/dashboards/dashboardl1/dashboard/ProbabilityStatus";
import LeadSource from "../../components/features/dashboards/dashboardl1/dashboard/LeadSource";
import LeadConversionRate from "../../components/features/dashboards/dashboardl1/dashboard/LeadConversionRate";
import HistoricalData from "../../components/features/dashboards/dashboardl1/dashboard/HistoricalData";
import RevenueDistribution from "../../components/features/dashboards/dashboardl1/dashboard/RevenueDistribution";
import { fetchEmployees } from "../../store/slices/employeeSlice";
import ProjectManager from "../Operations/OperationParent/ProjectManager";
import { hasViewOrFullAccess } from "../../utils/featureAccessUtils";
// import AddProject from "../Wizard/NewProjectWizard/AddProject";

const DashboardOne = () => {
    const popupRef = useRef(null);
    const [showLogout, setshowlogout] = useState(false);
    const dispatch = useDispatch();
    const { targetComponent } = useSelector((state) => state.scroll);
    const financeRef = useRef(null);
    const projectManagerRef = useRef(null);
    const operationRef = useRef(null);
    const salesOperationsRef = useRef(null);
    const profitLossTrackerRef = useRef(null); // Add this ref
    const { employees } = useSelector((state) => state.employees);
    const [currentEmployee, setcurrentEmployee] = useState();
    const email = localStorage.getItem("email")

    console.log("currentEmployee", currentEmployee)

    useEffect(() => {
        const employee = employees.find((emp) => emp.EmpEmail === email);
        console.log("fsgsdg", employee)
        setcurrentEmployee(employee)
    }, [email, employees]);

    const componentRefs = useMemo(
        () => ({
            "Profit and Loss Tracker": profitLossTrackerRef,
            "Project Manager": projectManagerRef,
            "Operations Person": operationRef,
            "Operations Tracker": salesOperationsRef,
        }),
        []
    );

    useEffect(() => {
        if (targetComponent && componentRefs[targetComponent]?.current) {
            let topOffset = 150; // Height of your fixed header in px
            if (targetComponent === "Operations Tracker") {
                topOffset = 10; // 👈 change this number to control scroll distance
            }
            if (targetComponent === "Profit and Loss Tracker") {
                topOffset = 10; // 👈 change this number to control scroll distance
            }
            const element = componentRefs[targetComponent].current;
            const y =
                element.getBoundingClientRect().top + window.scrollY - topOffset;
            window.scrollTo({ top: y, behavior: "smooth" });
            dispatch(clearScrollTarget());
        }
    }, [targetComponent, dispatch, componentRefs]);

    useEffect(() => {
        dispatch(setCurrentPageTitle("Dashboard"));
        dispatch(fetchEmployees());
    }, [dispatch]);

    const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
            setshowlogout(false); // Close the popup if clicked outside
        }
    };
    useEffect(() => {
        if (showLogout) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [showLogout]);

    const [userLevel, SetUserLevel] = useState("");
    const [customRole, setcustomRole] = useState([]);
    const { session } = useSelector((state) => state.session);


    console.log("fsgsg", userLevel)
    useEffect(() => {
        const authLevel = session?.auth || localStorage.getItem("auth");
        const rawRoles = session?.customRoles || localStorage.getItem("Roles");
        const customRoles = Array.isArray(rawRoles)
            ? rawRoles
            : typeof rawRoles === "string"
                ? [rawRoles]
                : [];
        if (authLevel === "L4" && customRoles.length > 0) {
            setcustomRole(customRoles);
        }
        SetUserLevel(authLevel);
    }, [session]);

    const ComponentAccessArrayTwo = useMemo(
        () => [
            {
                roles: ["L4", "project manager"],
                name: "Project Manager", 
                component: <ProjectManager />,
            },

            {
                roles: ["L4", "operations"],
                name: "Operations Person",
                component: <MyRequests />,
            },
            {
                roles: ["L0", "L1", "L3"],
                name: "Operations Tracker",
                component: (
                    <SalesProjects wrapperClasses="w-[100%]" />
                ),
            },
            {
                roles: ["L2", "L5"],
                name: "Profit and Loss Tracker",
                component: <Finance ref={financeRef} wrapperClasses="w-[100%]" />,
            },
            {
                roles: ["L0", "L1", "L3"],
                name: "Profit and Loss Tracker",
                component: <SalesFinaceFilter ref={financeRef} />,
            },
        ],
        []
    );

    const hasNoFeatureConfig =
        !Array.isArray(currentEmployee?.featureAccess) || currentEmployee.featureAccess.length === 0;

    // Strict featureAccess: show module only if user has at least one feature with View Only or Full Access under that module
    const canShowOperationTrackerSection = useMemo(() => {
        // Admin (L0): always show Operations Tracker (includes Task in hand), same idea as P&L / Lead Tracker
        if ((userLevel || "").toString().trim().toUpperCase() === "L0") return true;
        if (hasNoFeatureConfig) return false;
        return (
            hasViewOrFullAccess(currentEmployee, "MY REQUEST") ||
            hasViewOrFullAccess(currentEmployee, "TASK IN HAND") ||
            hasViewOrFullAccess(currentEmployee, "UTILISATION REPORT") ||
            hasViewOrFullAccess(currentEmployee, "MY TRAININGS")
        );
    }, [hasNoFeatureConfig, currentEmployee, userLevel]);

    const canShowLeadTrackerSection = useMemo(() => {
        // Admin (L0): always see Lead Tracker section, regardless of featureAccess
        if (userLevel === "L0") return true;
        if (hasNoFeatureConfig) return false;
        return (
            hasViewOrFullAccess(currentEmployee, "FOLLOW-UP-TABLE") ||
            hasViewOrFullAccess(currentEmployee, "POTENTIAL STATUS") ||
            hasViewOrFullAccess(currentEmployee, "PROBABILITY STATUS") ||
            hasViewOrFullAccess(currentEmployee, "LEAD SOURCE") ||
            hasViewOrFullAccess(currentEmployee, "LEAD CONVERSION RATE") ||
            hasViewOrFullAccess(currentEmployee, "HISTORICAL DATA") ||
            hasViewOrFullAccess(currentEmployee, "REVENUE DISTRIBUTION") ||
            hasViewOrFullAccess(currentEmployee, "ADD LEAD") ||
            hasViewOrFullAccess(currentEmployee, "EDIT LEAD") ||
            hasViewOrFullAccess(currentEmployee, "LEAD REPORTS") ||
            hasViewOrFullAccess(currentEmployee, "IMPORT LEADS") ||
            hasViewOrFullAccess(currentEmployee, "DOWNLOAD TEMPLATE") ||
            hasViewOrFullAccess(currentEmployee, "ATTACHMENTS")
        );
    }, [hasNoFeatureConfig, currentEmployee, userLevel]);

    // Show GROUP/CLIENT/YEAR filter bar when user has View/Full access to any module's FILTER
    const canShowLeadTrackerFilter = useMemo(() => {
        if (!currentEmployee) return true; // show until employee loaded
        if (userLevel === "L0") return true;
        if (hasNoFeatureConfig) return false;
        return (
            hasViewOrFullAccess(currentEmployee, "FOLLOW-UP-TABLE FILTER") ||
            hasViewOrFullAccess(currentEmployee, "POTENTIAL STATUS FILTER") ||
            hasViewOrFullAccess(currentEmployee, "PROBABILITY STATUS FILTER") ||
            hasViewOrFullAccess(currentEmployee, "LEAD SOURCE FILTER") ||
            hasViewOrFullAccess(currentEmployee, "LEAD CONVERSION RATE FILTER") ||
            hasViewOrFullAccess(currentEmployee, "HISTORICAL DATA FILTER") ||
            hasViewOrFullAccess(currentEmployee, "REVENUE DISTRIBUTION FILTER")
        );
    }, [userLevel, hasNoFeatureConfig, currentEmployee]);

    const canShowProfitAndLossSection = useMemo(() => {
        // Admin (L0): always see Profit & Loss / Gross Profit section
        if ((userLevel || "").toString().trim().toUpperCase() === "L0") return true;
        // L2/L5 (finance/accounting person): show if View Only or Full Access to PROFIT AND LOSS or G&A AND TAX
        if (userLevel === "L2" || userLevel === "L5") {
            if (hasNoFeatureConfig) return false;
            return (
                hasViewOrFullAccess(currentEmployee, "PROFIT AND LOSS") ||
                hasViewOrFullAccess(currentEmployee, "G&A AND TAX")
            );
        }
        // If featureAccess explicitly configured but has no P&L/Gross Profit features, hide section.
        if (hasNoFeatureConfig) return false;
        // P&L and Gross Profit Tracker are independent: either permission can mount the finance block
        // (SalesFinaceFilter shows P&L vs Gross Profit UI separately inside).
        return (
            hasViewOrFullAccess(currentEmployee, "PROFIT AND LOSS") ||
            hasViewOrFullAccess(currentEmployee, "PROFIT AND LOSS TRACKER") ||
            hasViewOrFullAccess(currentEmployee, "GROSS PROFIT TRACKER")
        );
    }, [hasNoFeatureConfig, currentEmployee, userLevel]);

    const canShowProjectManagerSection = useMemo(() => {
        if (hasNoFeatureConfig) return true;
        return (
            hasViewOrFullAccess(currentEmployee, "MY MANAGEMENT") ||
            hasViewOrFullAccess(currentEmployee, "MY ASSIGNEMENT") ||
            hasViewOrFullAccess(currentEmployee, "MY ASSIGNMENT") ||
            hasViewOrFullAccess(currentEmployee, "MY PROJECTS") ||
            hasViewOrFullAccess(currentEmployee, "APPROVED HRS") ||
            hasViewOrFullAccess(currentEmployee, "PRODUCTIVITY") ||
            hasViewOrFullAccess(currentEmployee, "PROJECTS & TIME ENTRIES") ||
            hasViewOrFullAccess(currentEmployee, "MY REQUEST") ||
            hasViewOrFullAccess(currentEmployee, "TASK IN HAND") ||
            hasViewOrFullAccess(currentEmployee, "UTILISATION REPORT") ||
            hasViewOrFullAccess(currentEmployee, "MY TRAININGS") ||
            hasViewOrFullAccess(currentEmployee, "PROFIT AND LOSS") ||
            hasViewOrFullAccess(currentEmployee, "OPERATIONS RATES HOURLY RATES & EXPENSES") ||
            hasViewOrFullAccess(currentEmployee, "SALES HOURLY RATES ADD HOURLY RATES")
        );
    }, [hasNoFeatureConfig, currentEmployee]);

    const canShowOperationsPersonSection = useMemo(() => {
        if (hasNoFeatureConfig) return true;
        return (
            hasViewOrFullAccess(currentEmployee, "MY PROJECTS") ||
            hasViewOrFullAccess(currentEmployee, "APPROVED HRS") ||
            hasViewOrFullAccess(currentEmployee, "PRODUCTIVITY") ||
            hasViewOrFullAccess(currentEmployee, "PROJECTS & TIME ENTRIES") ||
            hasViewOrFullAccess(currentEmployee, "MY REQUEST") ||
            hasViewOrFullAccess(currentEmployee, "TASK IN HAND") ||
            hasViewOrFullAccess(currentEmployee, "UTILISATION REPORT") ||
            hasViewOrFullAccess(currentEmployee, "MY TRAININGS")
        );
    }, [hasNoFeatureConfig, currentEmployee]);

    return (
        <>
            <div className="dashboard-page">


                {canShowLeadTrackerSection && (
                    <div>
                        <div> <DashFilters showFilterBar={canShowLeadTrackerFilter} /></div>
                        <div className="pt-3">
                            {/* <FollowupTableL1 /> */}
                            {/* {(((!currentEmployee?.featureAccess) || (currentEmployee?.featureAccess?.length === 0) )
                                (currentEmployee?.featureAccess?.includes("FOLLOW-UP-TABLE") && (currentEmployee?.EmpAuthLevel !== "L1" || currentEmployee?.EmpAuthLevel !== "L0"))) && (
                                    <FollowupTable />
                                )} */}

                            {(
                                (hasNoFeatureConfig ||
                                    hasViewOrFullAccess(currentEmployee, "FOLLOW-UP-TABLE"))
                            ) && <FollowupTable currentEmployee={currentEmployee} hasNoFeatureConfig={hasNoFeatureConfig} userLevel={userLevel} />}

                            {/* <AddProject /> */}
                        </div>
                    </div>
                )}

                {canShowLeadTrackerSection && (
                    <div className="grid grid-cols-2 items-stretch gap-4 pt-2 pb-1">
                        {(
                            hasNoFeatureConfig ||
                            hasViewOrFullAccess(currentEmployee, "POTENTIAL STATUS")
                        ) && (
                                <div className="flex h-full min-h-0 min-w-0"><PotentialStatus currentEmployee={currentEmployee} hasNoFeatureConfig={hasNoFeatureConfig} userLevel={userLevel} /></div>
                            )}

                        {(
                            hasNoFeatureConfig ||
                            hasViewOrFullAccess(currentEmployee, "PROBABILITY STATUS")
                        ) && (
                                <div className="flex h-full min-h-0 min-w-0"><ProbabilityStatus currentEmployee={currentEmployee} hasNoFeatureConfig={hasNoFeatureConfig} userLevel={userLevel} /></div>
                            )}

                        {(
                            hasNoFeatureConfig ||
                            hasViewOrFullAccess(currentEmployee, "LEAD SOURCE")
                        ) && (
                                <div className="flex h-full min-h-0 min-w-0 w-full"><LeadSource currentEmployee={currentEmployee} hasNoFeatureConfig={hasNoFeatureConfig} userLevel={userLevel} /></div>
                            )}

                        {(
                            hasNoFeatureConfig ||
                            hasViewOrFullAccess(currentEmployee, "LEAD CONVERSION RATE")
                        ) && (
                                <div className="flex h-full min-h-0 min-w-0 w-full"><LeadConversionRate currentEmployee={currentEmployee} hasNoFeatureConfig={hasNoFeatureConfig} userLevel={userLevel} /></div>
                            )}

                        {(
                            hasNoFeatureConfig ||
                            hasViewOrFullAccess(currentEmployee, "HISTORICAL DATA")
                        ) && (
                                <div className="flex h-full min-h-0 min-w-0"><HistoricalData currentEmployee={currentEmployee} hasNoFeatureConfig={hasNoFeatureConfig} userLevel={userLevel} /></div>
                            )}

                        {(
                            hasNoFeatureConfig ||
                            hasViewOrFullAccess(currentEmployee, "REVENUE DISTRIBUTION")
                        ) && (
                                <div className="flex h-full min-h-0 min-w-0"><RevenueDistribution currentEmployee={currentEmployee} hasNoFeatureConfig={hasNoFeatureConfig} userLevel={userLevel} /></div>
                            )}
                    </div>
                )}
            </div>


            <div className="w-full flex flex-wrap">
                <div className="w-full flex flex-wrap">
                    {(userLevel === "L4"
                        ? (() => {
                            const l4Component = ComponentAccessArrayTwo.find(
                                (c) =>
                                    c.roles?.includes("L4") &&
                                    Array.isArray(customRole) &&
                                    customRole.some((role) => c.roles.includes(role))
                            );
                            if (!l4Component) return [];
                            if (l4Component.name === "Project Manager" && !canShowProjectManagerSection) return [];
                            if (l4Component.name === "Operations Person" && !canShowOperationsPersonSection) return [];
                            return [l4Component];
                        })()
                        : ComponentAccessArrayTwo.filter((c) =>
                            c.roles?.includes(userLevel) &&
                            (c.name !== "Operations Tracker" || canShowOperationTrackerSection) &&
                            (c.name !== "Profit and Loss Tracker" || canShowProfitAndLossSection)
                        )
                    ).map((c, index) => {
                        const ref = componentRefs[c.name] || null;

                        return (
                            <div key={index} ref={ref} className="w-full">
                                {c.component}
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export default DashboardOne;
